<app-order-summary  [order]="order$ | async"
                [validatedTerms]="contextService.fullContext.customer?.hasValidatedTerms" [isMobile]="isMobile" 
                   (cancelOrderEmitter)="cancelOrder()" (reactivateOrderEmitter)="reactivateOrder()" (validateOrderEmitter)="validateOrder()" (continueOrderEmitter)="continueOrder()">
</app-order-summary>

<app-catalog *ngIf="catalog" [catalog]="catalog"></app-catalog>